module.exports = __webpack_public_path__ + "static/image/sustainability/m/img-protection-2@3x.ver2_0_2.png?b6cf8f19";